import type { CSS } from '@grupoboticario/flora-react'

export const centeredPredominantCss: CSS = {
  textAlign: 'center',
  color: '$nonInteractivePredominant'
}

export const predominantTextCss: CSS = {
  color: '$nonInteractivePredominant'
}

export const auxTextCss: CSS = {
  color: '$nonInteractiveAuxiliar'
}

export const dateFlexCss: CSS = {
  width: '100%',
  paddingRight: '8px'
}

export const successTextCss: CSS = {
  color: '$success-standard'
}
